import React, { useEffect } from "react";
import { useNavigate, useOutletContext } from "react-router";
import styled, { css } from "styled-components";
import { devices } from "../../Devices";
import { IonIcon } from "@ionic/react";
import { arrowBackOutline, returnUpBack } from "ionicons/icons";

export const LogoIconWrapper = styled.div`
  max-height: 80px;
  gap: 0.6rem;
  @media ${devices.tablet} {
    gap: 0.4rem;
  }

  .premium {
  }
  .premium span {
    font-weight: bold;
    color: #ffb743;
    display: inline-block;
    line-height: 1;
    text-align: center;
  }
`;

const Icon = styled.div`
  width: 2.5rem;
  height: 2.5rem;
  ${({ size }) => css`
    width: ${size / 3}rem;
    height: ${size / 3}rem;
  `}
  @media ${devices.tablet} {
    width: 1.8rem;
    height: 1.8rem;
  }
  ${(url) =>
    url &&
    css`
      background-image: url(/images/crown.png);
      background-size: cover;
    `}
`;

const ReturnIconWrapper = styled.div`
  font-size: 2rem;
  margin-right: 3rem;
  cursor: pointer;
  transition: all 200ms ease-in-out;
  &:hover {
    color: #d97706;
  }
  @media ${devices.tablet} {
    font-size: 1.4rem;
    margin-right: 1.8rem;
  }
  ${({ color }) => css`
    ${color === "white"
      ? "color: #fff; &:hover {color: #fff; opacity: .6;}; "
      : ""};
  `}
`;

const LogoImage = styled.div`
  background-image: url("/logo.png");
  ${({ size, color }) => css`
    width: ${size ? size : 8}rem;
    height: ${size ? size : 8}rem;
    background-image: url(${color === "white"
      ? "images/ofertasexpress-white.png"
      : "/images/ofertasexpress.png"});
  `}
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`;
export default function Logo({
  showGoBackButton,
  path,
  navigable,
  size,
  color,
  className = "logo",
}) {
  const context = useOutletContext();
  const navigate = useNavigate();
  return (
    <LogoIconWrapper className={`flex justify align ${className}`}>
      <div className="flex align ">
        {showGoBackButton && (
          <ReturnIconWrapper
            color={color}
            className="flex align"
            onClick={() => navigate(path)}
          >
            <IonIcon icon={arrowBackOutline} />
          </ReturnIconWrapper>
        )}
        <LogoImage
          color={color}
          size={size}
          onClick={() => {
            if (navigable) navigate("/");
          }}
        />
      </div>

      {context && context.activeAccount && (
        <Icon size={size} className="icon" url={"/images/crown.png"} />
      )}
    </LogoIconWrapper>
  );
}
